/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useAlert } from 'react-alert'

import {
  contactsModel,
  CustomerModel,
  MaritalStatusModel,
  NationalityModel,
  NaturalnessModel,
  SchoolingModel,
  TypedocumentsModel,
  AddressModel
} from '../../../domain/models'
import {
  fetchListDocuments,
  fetchListMaritalStatus,
  fetchListNationalities,
  fetchListNaturalities,
  fetchListSchooling,
  createCustomer,
  deleteCustomerAnddress,
  deleteCustomerContact,
  deleteCustomerDocument,
  updateCustomer
} from '../../../main/usecases'

import { goToUrl, maskCpf } from '../../utils'
import { useOnChangeDetect } from '../../contexts'
import {
  Checkbox,
  Input,
  Button,
  Textarea,
  AddressCard,
  ContactCard,
  DocumentsCard,
  SelectInputSearch
} from '..'

import { IconDropdownSvg, IconSaveSvg } from '../../assets/icons/svgComponents'

import * as S from './styles'

const RegistrationDataForms = ({ customer, stateValues }: any) => {
  const [listNationalities, setListNationalities] = useState<
    NationalityModel[]
  >([])
  const [naturalities, setNaturalities] = useState<NaturalnessModel[]>([])
  const [isLoadingNaturalities, setIsLoadingNaturalities] =
    useState<boolean>(false)
  const [listMaritalStatus, setListMaritalStatus] = useState<
    MaritalStatusModel[]
  >([])
  const [listSchooling, setListSchooling] = useState<SchoolingModel[]>([])
  const [listDocuments, setListDocuments] = useState<TypedocumentsModel[]>()
  const [data, setData] = useState<CustomerModel>()
  const [dataAddress, setDataAddress] = useState<AddressModel>(
    {} as AddressModel
  )
  const [dataContacts, setDataContacts] = useState<contactsModel>(
    {} as contactsModel
  )
  const [dataDocuments, setDataDocuments] = useState<any>({})
  const [dropdownIsOpen, setDropdownIsOpen] = useState(false)
  const [loading, setLoading] = useState(false)
  const [addresses, setAddresses] = useState<any[]>([])
  const [contacts, setContacts] = useState<any[]>([])
  const alert = useAlert()
  const history = useHistory()
  const { setRefresh, refresh } = useOnChangeDetect()

  const optionsListNationalities = useMemo(
    () =>
      listNationalities?.map((item) => {
        return { value: item?.cdPais, label: item?.gentilico }
      }),
    [listNationalities]
  )

  const optionsListMaritalStatus = useMemo(
    () =>
      listMaritalStatus?.map((item) => {
        return { value: item?.cdEstadoCivil, label: item?.estadoCivil }
      }),
    [listMaritalStatus]
  )

  const optionsListSchooling = useMemo(
    () =>
      listSchooling?.map((item) => {
        return { value: item?.cdEscolaridade, label: item?.escolaridade }
      }),
    [listSchooling]
  )

  const handleRemove = async ({
    item,
    setControllerState,
    fetchDelete,
    card,
    position
  }: any) => {
    try {
      if (item?.cdContato || item?.cdEndereco) {
        await fetchDelete({
          id: item?.cdContato || item?.cdEndereco
        }).delete()
        alert.show(`${card} deletado com sucesso`, {
          type: 'success',
          timeout: 1000
        })
        setRefresh((prev: any) => !prev)
      } else if (position >= 0) {
        setControllerState((prev: any) =>
          prev.filter((_: any, i: any) => i !== position)
        )
      }
    } catch (error) {
      console.error(error)
      alert.show(`Erro ao deletar um ${card}`, {
        type: 'error',
        timeout: 4000
      })
    }
  }

  const removeDocuments = async (index: any, removeFunction: any, id: any) => {
    let temp: any = {}

    Object.entries(dataDocuments).forEach(([key, value]) => {
      if (index.toString() !== key.toString()) {
        temp = { ...temp, [key]: value }
      }
    })

    setDropdownIsOpen(false)
    setDataDocuments(temp)

    if (removeFunction && id) {
      try {
        await removeFunction({ id }).delete()

        alert.show(`Documento deletado com sucesso`, {
          type: 'success',
          timeout: 1000
        })

        setRefresh((prev: any) => !prev)
      } catch (error) {
        console.error(error)
        alert.show(`Erro ao deletar um Documento`, {
          type: 'error',
          timeout: 4000
        })
      }
    }
  }

  const addDocuments = (item: any) => {
    setDropdownIsOpen(false)
    setDataDocuments((el: any) => ({
      ...el,
      [Object.keys(el)?.length]: {
        tipoDocumento: {
          descricao: item.descricao,
          cdTipoDocumento: item.cdTipoDocumento
        }
      }
    }))
  }

  const addAddress = () => {
    setAddresses([...addresses, { address: '' }])
  }

  const addContact = () => {
    setContacts([...contacts, { contact: '' }])
  }

  useEffect(() => {
    ;(async () => {
      try {
        if (data?.nacionalidade?.cdPais) {
          setIsLoadingNaturalities(true)
          const responseNaturalities = await fetchListNaturalities({
            id: data?.nacionalidade?.cdPais,
            name: ''
          }).load()
          setNaturalities(responseNaturalities)
        }
      } catch (error) {
        console.error(error)
      } finally {
        setIsLoadingNaturalities(false)
      }
    })()
  }, [data?.nacionalidade?.cdPais])

  useEffect(() => {
    ;(async () => {
      try {
        const responseListNationalities = await fetchListNationalities().load()
        setListNationalities(responseListNationalities)
        const responseListMaritalStatus = await fetchListMaritalStatus().load()
        setListMaritalStatus(responseListMaritalStatus)
        const responseListSchooling = await fetchListSchooling().load()
        setListSchooling(responseListSchooling)
        const responseListDocuments = await fetchListDocuments().load()
        setListDocuments(responseListDocuments)
        if (stateValues) {
          setData((prev: any) => ({
            ...prev,
            cpf: stateValues.cpf,
            nome: stateValues.name,
            dataNascimento: stateValues.birth
          }))
        } else {
          setData(customer)
          setAddresses([])
          setContacts([])

          let objDocuments: any = {}
          let objAddresses: any = {}
          let objContacts: any = {}

          customer?.documentos?.forEach((item: any, index: number) => {
            objDocuments = { ...objDocuments, [index]: item }
          })

          setDataDocuments(objDocuments)

          customer?.enderecos?.forEach((item: any, index: number) => {
            objAddresses = { ...objAddresses, [index]: item }
            setAddresses((prev) => [...prev, { address: '' }])
          })

          customer?.contatos?.forEach((item: any, index: number) => {
            objContacts = { ...objContacts, [index]: item }
            setContacts((prev) => [...prev, { contact: '' }])
          })

          setDataContacts(objContacts)
          setDataAddress(objAddresses)
        }
      } catch (error) {
        console.error(error)
      }
    })()
  }, [customer, stateValues, refresh])

  const submitAndContinue = async (event: any) => {
    event.preventDefault()

    if (!data?.nome) {
      alert.show(`Preencha os dados obrigatórios`, {
        type: 'error',
        timeout: 4000
      })
      return
    }

    if (!data?.cpf) {
      alert.show(`Preencha os dados obrigatórios`, {
        type: 'error',
        timeout: 4000
      })
      return
    }

    if (
      data?.naturalidade.nome &&
      !naturalities?.find(
        (item) => item.cdMunicipio === data?.naturalidade.cdMunicipio
      )
    ) {
      // se naturalizdade preenchida, e nao faz parte da lista de naturalidade -> error
      alert.show(`Preencha a Naturalidade corretamente`, {
        type: 'error',
        timeout: 4000
      })
      return
    }

    const body: any = {
      ...(data?.cdCliente && { cdCliente: data?.cdCliente }),
      nome: data?.nome,
      cpf: data?.cpf,
      dataNascimento: data?.dataNascimento,
      sexo: data?.sexo,
      email: data?.email,
      observacao: data?.observacao,
      ...(data?.nacionalidade && {
        nacionalidade: {
          cdPais: data?.nacionalidade?.cdPais
        }
      }),
      ...(data?.naturalidade && {
        naturalidade: {
          cdMunicipio: data?.naturalidade?.cdMunicipio
        }
      }),
      profissao: data?.profissao,
      ...(data?.escolaridade && {
        escolaridade: {
          cdEscolaridade: data?.escolaridade?.cdEscolaridade
        }
      }),
      ...(data?.estadoCivil && {
        estadoCivil: {
          cdEstadoCivil: data?.estadoCivil?.cdEstadoCivil
        }
      }),
      nomeMae: data?.nomeMae,
      nomePai: data?.nomePai,
      documentos: Object?.values(dataDocuments || {}).map(
        (documents: any, index) => ({
          ...documents,
          principal:
            index?.toString() ===
            event?.target?.radioDocuments?.value?.toString()
        })
      ),
      enderecos: Object?.values(dataAddress || {}).map(
        (address: any, index) => ({
          ...address,
          principal:
            index?.toString() ===
            event?.target?.radioAnddress?.value?.toString()
        })
      ),
      contatos: Object?.values(dataContacts || {}).map(
        (contant: any, index) => ({
          ...contant,
          principal:
            index?.toString() === event?.target?.radioContant?.value?.toString()
        })
      )
    }

    try {
      setLoading(true)

      await createCustomer().post(body)
      alert.show('Paciente cadastrado com sucesso.', {
        type: 'success',
        timeout: 4000
      })

      window.scrollTo(0, 0)
      setData({
        cpf: '',
        nome: '',
        dataNascimento: '',
        email: '',
        sexo: '',
        nacionalidade: { cdPais: 202 },
        naturalidade: null,
        profissao: '',
        escolaridade: { cdEscolaridade: 1 },
        estadoCivil: { cdEstadoCivil: 1 },
        nomeMae: '',
        nomePai: '',
        observacao: ''
      } as any)
      stateValues.cpf = ''
      stateValues.birth = ''
      stateValues.name = ''
      setDataDocuments({})
      setAddresses([])
      setContacts([])
      setRefresh((prev: any) => !prev)
    } catch (error) {
      alert.show(
        (error as Error).message || 'Erro ao cadastrar/atualizar dados.',
        {
          type: 'error',
          timeout: 4000
        }
      )
    } finally {
      setLoading(false)
    }
  }

  const onSubmit = async (event: any) => {
    event.preventDefault()

    const body: any = {
      ...(data?.cdCliente && { cdCliente: data?.cdCliente }),
      nome: data?.nome,
      cpf: data?.cpf,
      dataNascimento: data?.dataNascimento,
      sexo: data?.sexo,
      email: data?.email,
      observacao: data?.observacao,
      ...(data?.nacionalidade && {
        nacionalidade: {
          cdPais: data?.nacionalidade?.cdPais
        }
      }),
      ...(data?.naturalidade && {
        naturalidade: {
          cdMunicipio: data?.naturalidade?.cdMunicipio
        }
      }),
      profissao: data?.profissao,
      ...(data?.escolaridade && {
        escolaridade: {
          cdEscolaridade: data?.escolaridade?.cdEscolaridade
        }
      }),
      ...(data?.estadoCivil && {
        estadoCivil: {
          cdEstadoCivil: data?.estadoCivil?.cdEstadoCivil
        }
      }),
      nomeMae: data?.nomeMae,
      nomePai: data?.nomePai,
      documentos: Object?.values(dataDocuments || {}).map(
        (documents: any, index) => ({
          ...documents,
          principal:
            index.toString() === event.target.radioDocuments.value.toString()
        })
      ),
      enderecos: Object?.values(dataAddress || {}).map(
        (address: any, index) => ({
          ...address,
          principal:
            index?.toString() ===
            event?.target?.radioAnddress?.value?.toString()
        })
      ),
      contatos: Object?.values(dataContacts || {}).map(
        (contant: any, index) => ({
          ...contant,
          principal:
            index?.toString() === event?.target?.radioContant?.value?.toString()
        })
      )
    }

    try {
      setLoading(true)
      if (data?.cdCliente) {
        await updateCustomer({
          id: data.cdCliente
        }).update(body)
        alert.show('Dados atualizados com sucesso.', {
          type: 'success',
          timeout: 4000
        })

        goToUrl(history, `/meus-pacientes/${data?.cdCliente}/prontuario`)
      } else {
        const response = await createCustomer().post(body)
        alert.show('Paciente cadastrado com sucesso.', {
          type: 'success',
          timeout: 4000
        })

        goToUrl(history, `/meus-pacientes/${response.cdCliente}/prontuario`)
      }
    } catch (error) {
      alert.show(
        (error as Error).message || 'Erro ao cadastrar/atualizar dados.',
        {
          type: 'error',
          timeout: 4000
        }
      )
    } finally {
      setLoading(false)
    }
  }

  return (
    <S.Wrapper onSubmit={onSubmit}>
      <S.TitleContainer>
        <S.Title>Dados Gerais</S.Title>
        <S.HeaderButtonContainer
          positionInPage={!!customer}
          width={customer ? '20%' : '48%'}
        >
          {customer ? (
            <Button
              disabled={loading}
              type="submit"
              initialIcon={<IconSaveSvg />}
            >
              {loading ? 'Salvando...' : 'Salvar'}
            </Button>
          ) : (
            <>
              <Button
                disabled={loading}
                type="submit"
                initialIcon={<IconSaveSvg />}
              >
                {loading ? 'Salvando...' : 'Salvar'}
              </Button>
              <Button
                type="button"
                onClick={(e: any) => submitAndContinue(e)}
                disabled={loading}
                initialIcon={<IconSaveSvg />}
              >
                {loading ? 'Salvando...' : 'Salvar e incluir novo'}
              </Button>
            </>
          )}
        </S.HeaderButtonContainer>
      </S.TitleContainer>
      <S.RegistrationContainer>
        <Input
          labelColor="#4F4F4F"
          label="CPF*"
          name="cpf"
          type="text"
          required
          error={!data?.cpf?.length ? 'Preencha um cpf' : ''}
          maxLength={14}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setData((prev: any) => ({ ...prev, cpf: e.target.value }))
          }
          value={maskCpf(data?.cpf)}
        />
        <Input
          labelColor="#4F4F4F"
          label="Nome*"
          name="nome"
          type="text"
          required
          error={!data?.nome?.length ? 'Preencha um nome' : ''}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setData((prev: any) => ({ ...prev, nome: e.target.value }))
          }
          value={data?.nome}
        />
        <Input
          labelColor="#4F4F4F"
          label="Data de nascimento"
          name="data de nascimento"
          type="date"
          onChange={(e: React.ChangeEvent<HTMLDataElement>) =>
            setData((prev: any) => ({
              ...prev,
              dataNascimento: e.target.value
            }))
          }
          value={data?.dataNascimento}
          max={'2222-10-29'}
        />
        <Input
          labelColor="#4F4F4F"
          label="E-mail"
          name="email"
          type="email"
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setData((prev: any) => ({
              ...prev,
              email: e.target.value
            }))
          }
          value={data?.email}
        />
        <SelectInputSearch
          labelColor="#4F4F4F"
          hasSelectOption={false}
          label="Sexo/Gênero"
          name="sexo/genero"
          onChange={(e: any) =>
            setData((prev: any) => ({
              ...prev,
              sexo: e
            }))
          }
          value={{
            label: data?.sexo,
            value: data?.sexo || null
          }}
          options={[
            { label: '', value: '' },
            { label: 'Masculino', value: 'Masculino' },
            { label: 'Feminino', value: 'Feminino' }
          ]}
          isSearchable={false}
        />
        <SelectInputSearch
          labelColor="#4F4F4F"
          hasSelectOption={false}
          label="Nacionalidade"
          name="nacionalidade"
          onChange={(e: any) => {
            setData((prev: any) => ({
              ...prev,
              nacionalidade: {
                ...prev?.nacionalidade,
                cdPais: Number(e)
              },
              naturalidade: null
            }))
          }}
          value={optionsListNationalities.find(
            (item) => item.value === data?.nacionalidade?.cdPais
          )}
          options={optionsListNationalities || []}
        />
        <SelectInputSearch
          labelColor="#4F4F4F"
          label="Naturalidade"
          disabled={
            !data?.nacionalidade?.cdPais || data?.nacionalidade?.cdPais === 202
          }
          name="naturalidade"
          onChange={(value: any) => {
            setData((prev: any) => ({
              ...prev,
              naturalidade: {
                ...prev.naturalidade,
                cdMunicipio: value.cdMunicipio,
                nome: value.nome
              }
            }))
          }}
          value={{
            label: data?.naturalidade?.nome || '',
            value: {
              nome: data?.naturalidade?.nome,
              cdMunicipio: data?.naturalidade?.cdMunicipio
            }
          }}
          options={naturalities.map((nati) => ({
            label: nati.nome,
            value: nati
          }))}
          loading={isLoadingNaturalities}
        />
        <Input
          labelColor="#4F4F4F"
          label="Profissão"
          name="profissão"
          maxLength={100}
          type="text"
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setData((prev: any) => ({
              ...prev,
              profissao: e.target.value
            }))
          }
          value={data?.profissao}
        />
        <SelectInputSearch
          labelColor="#4F4F4F"
          hasSelectOption={false}
          label="Escolaridade"
          name="escolaridade"
          onChange={(e: any) =>
            setData((prev: any) => ({
              ...prev,
              escolaridade: {
                ...prev.escolaridade,
                cdEscolaridade: Number(e)
              }
            }))
          }
          value={optionsListSchooling.find(
            (item) => item.value === data?.escolaridade?.cdEscolaridade
          )}
          options={optionsListSchooling}
        />
        <SelectInputSearch
          labelColor="#4F4F4F"
          hasSelectOption={false}
          label="Estado civil"
          name="estado civil"
          onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
            setData((prev: any) => ({
              ...prev,
              estadoCivil: {
                ...prev.estadoCivil,
                cdEstadoCivil: Number(e)
              }
            }))
          }
          value={optionsListMaritalStatus.find(
            (item) => item.value === data?.estadoCivil?.cdEstadoCivil
          )}
          options={optionsListMaritalStatus}
        />
        <Input
          labelColor="#4F4F4F"
          label="Mãe"
          name="Mae"
          type="text"
          maxLength={150}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setData((prev: any) => ({
              ...prev,
              nomeMae: e.target.value
            }))
          }
          value={data?.nomeMae}
        />
        <Input
          labelColor="#4F4F4F"
          label="Pai"
          name="pai"
          maxLength={150}
          type="text"
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setData((prev: any) => ({
              ...prev,
              nomePai: e.target.value
            }))
          }
          value={data?.nomePai}
        />
      </S.RegistrationContainer>

      <S.TitleWithButton>
        Documentos
        <Button
          type="button"
          onClick={() => {
            setDropdownIsOpen(!dropdownIsOpen)
          }}
          endIcon={<IconDropdownSvg />}
          hasSecodaryButton
          className="button-add"
        >
          Adicionar +
        </Button>
        {dropdownIsOpen && (
          <>
            <S.DropdownContainer>
              {listDocuments &&
                listDocuments.map((item) => (
                  <Checkbox
                    isChecked={
                      !!Object.values(dataDocuments || {}).find(
                        (document: any) =>
                          document?.tipoDocumento?.cdTipoDocumento ===
                          item?.cdTipoDocumento
                      )
                    }
                    key={item?.cdTipoDocumento}
                    name={item?.descricao}
                    label={item?.descricao}
                    labelFor={item?.descricao}
                    onChange={() => {
                      const checked = Object.values(dataDocuments || {}).find(
                        (document: any) =>
                          document?.tipoDocumento?.cdTipoDocumento ===
                          item?.cdTipoDocumento
                      )
                      if (!checked) {
                        addDocuments(item)
                      }
                    }}
                  />
                ))}
            </S.DropdownContainer>
          </>
        )}
      </S.TitleWithButton>
      {dataDocuments &&
        Object.entries(dataDocuments || {})?.map(([key, value]) => {
          return (
            <DocumentsCard
              onChangeComponent={(item: any) =>
                setDataDocuments((prev: any) => {
                  if (!prev) return prev

                  return { ...prev, [key]: item }
                })
              }
              defaultValue={value}
              onDelete={() =>
                removeDocuments(
                  key,
                  deleteCustomerDocument,
                  dataDocuments[key]?.cdDocumento || null
                )
              }
              index={key}
              key={key}
            />
          )
        })}

      <S.TitleWithButton>
        Endereços
        <Button
          type="button"
          onClick={() => addAddress()}
          hasSecodaryButton
          className="button-add"
        >
          Adicionar +
        </Button>
      </S.TitleWithButton>
      {addresses.map((_, index) => {
        return (
          <AddressCard
            onChangeComponent={(item: any) => {
              setDataAddress((prev: any) => {
                if (!prev) return prev

                return { ...prev, [index]: item }
              })
            }}
            defaultValue={data?.enderecos?.length && data?.enderecos[index]}
            index={index}
            onDelete={() => {
              handleRemove({
                item: Object.values(dataAddress || {}).find(
                  (address: any, i: any) => {
                    if (i === index) {
                      return address
                    }
                    return null
                  }
                ),
                setControllerState: setAddresses,
                fetchDelete: deleteCustomerAnddress,
                card: 'Endereço',
                position: index
              })
            }}
            key={index}
          />
        )
      })}

      <S.TitleWithButton>
        Contatos
        <Button
          className="button-add"
          hasSecodaryButton
          type="button"
          onClick={() => {
            addContact()
          }}
        >
          Adicionar +
        </Button>
      </S.TitleWithButton>
      {contacts.map((_, index) => {
        return (
          <ContactCard
            onChangeComponent={(item: any) => {
              setDataContacts((prev: any) => {
                if (!prev) return prev

                return { ...prev, [index]: item }
              })
            }}
            defaultValue={data?.contatos?.length && data?.contatos[index]}
            index={index}
            onDelete={() => {
              handleRemove({
                item: Object.values(dataContacts || {}).find(
                  (contact: any, i: any) => {
                    if (i === index) {
                      return contact
                    }
                    return null
                  }
                ),
                setControllerState: setContacts,
                fetchDelete: deleteCustomerContact,
                card: 'Contato',
                position: index
              })
            }}
            key={index}
          />
        )
      })}

      <S.TitleContainer>
        <S.Title>Observações</S.Title>
      </S.TitleContainer>
      <Textarea
        label="Observações"
        labelColor="#4F4F4F"
        name="observacao"
        onChange={(e: any) =>
          setData((prev: any) => ({
            ...prev,
            observacao: e.target.value
          }))
        }
        value={data?.observacao}
      />

      <S.ButtonContainer>
        <Button disabled={loading} initialIcon={<IconSaveSvg />}>
          {loading ? 'Salvando...' : 'Salvar'}
        </Button>
        {!customer && (
          <Button
            type="button"
            onClick={(e: any) => submitAndContinue(e)}
            disabled={loading}
            initialIcon={<IconSaveSvg />}
          >
            {loading ? 'Salvando...' : 'Salvar e incluir novo'}
          </Button>
        )}
      </S.ButtonContainer>
    </S.Wrapper>
  )
}
export default RegistrationDataForms
